<div class="primary-entity-show">
    <div (click)="moreOrLessEntityData(false)" class="columns-container">
        <material-button [buttonType]="'raised'" [color]="'primary'" class="entity-name" [classList]="['whitespace-nowrap']" [hideRipple]="true" [text]="primaryEntity?.entityData?.displayName"></material-button>
        <div class="primary-entity-details-container">
            <ng-container *ngFor="let field of record?.fields | PrimaryHeaderRecordFields : record; let i = index">
                <span class="entity-detail !flex" *ngIf="i < 5">
                    <span class="record-key" [textContent]="field?.displayName + ' :'"></span>
                    <span class="record-value">
                        <app-common-templates [fieldValue]="field.value" [valueDisplayFormat]="field.valueDisplayFormat"></app-common-templates>
                    </span>
                </span>
            </ng-container>
        </div>
        <mat-icon class="show-more" [textContent]="showBtnContent === 'Show More' ? 'keyboard_arrow_right' : 'keyboard_arrow_up'"></mat-icon>
    </div>
    <div class="clearfix"></div>
    <mat-divider class="separator clearfix"></mat-divider>
    <div *ngIf="primaryEntity?.primary && primaryEntity?.show" class="nonBusinessKeys clearfix primaryDataContainer hidden">
        <div class="outside-click-container" (appAppDetectOutsideClick)="moreOrLessEntityData(true)">
            <div class="columns-container more-details-curtain">
                <ng-container *ngFor="let field of record?.fields | PrimaryHeaderRecordFields : record; let i = index">
                    <ng-container *ngIf="i >= 5">
                        <span class="record-item !flex">
                            <span class="record-key" [textContent]="field?.displayName + ' :'"></span>
                            <span class="record-value">
                                <app-common-templates [fieldValue]="field.value" [valueDisplayFormat]="field.valueDisplayFormat"></app-common-templates>
                            </span>
                        </span>
                    </ng-container>
                </ng-container>
                <ng-container *ngFor="let field of record?.fields | PrimarySubHeaderRecordFields : record; let i = index">
                    <div class="record-item !flex">
                        <span class="record-key" [textContent]="field?.displayName + ' :'"></span>
                        <span class="record-value">
                            <app-common-templates [fieldValue]="field.value" [valueDisplayFormat]="field.valueDisplayFormat"></app-common-templates>
                        </span>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
